import React from 'react';
import PropTypes from 'prop-types';

import { strings } from '../../../../localization';
import ProgressOverlay from '../../../../components/common/ProgressOverlay';
import { ModalContainer } from '../../../../components/common/Modal2';


import { UPDATE_SETTINGS_TIMEOUT } from '../GlobalSettings';


async function RRW_SIMULATE_DELAY_DEV_ONLY(delayTime = 3000) {
    await new Promise(resolve => setTimeout(resolve, delayTime));
}

const API_KEY_MIN_LENGTH = 40

export default class WhiparoundIntegration extends React.PureComponent {

    static propTypes = {
        integrationsWhiparoundCredentialsPending: PropTypes.bool.isRequired,
        timeoutIntegrationsWhiparoundCredentials: PropTypes.func.isRequired,
        integrationsWhiparoundCredentialsApiKey: PropTypes.string,
        integrationsWhiparoundCredentialsIntegrationId: PropTypes.string,
        applyIntegrationsWhiparoundCredentials: PropTypes.func.isRequired,
        integrationsWhiparoundCredentialsStatus: PropTypes.string,
        integrationsWhiparoundCredentialsErrorMessage: PropTypes.string,
        integrationsWhiparoundCredentialsStatusMessage: PropTypes.string,
        integrationsWhiparoundCredentialsVerificationPending: PropTypes.bool,
        integrationsWhiparoundCredentialsVerificationIsValid: PropTypes.bool,
        integrationsWhiparoundCredentialsVerificationErrorMessage: PropTypes.string,
        showConfirmationDialog: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        integrationsExpandReference: PropTypes.string.isRequired,
        integrationsExpandReferenceIsExpanded: PropTypes.bool.isRequired,
        integrationsWhiparoundCredentialsExpandReference: PropTypes.string.isRequired,
        integrationsWhiparoundCredentialsExpandReferenceIsExpanded: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        this.state = {
            whiparoundIntegrationCredentialsVerificationPending: false,
            whiparoundIntegrationCredentialsVerificationSucceeded: false,
            whiparoundIntegrationCredentialsVerificationFailed: false,
            whiparoundIntegrationCredentialsVerificationErrorMessage: null,
            moreInfoTooltipVisible: false
        };

        this.applyIntegrationsWhiparoundCredentialsTimeoutId = undefined;
    }

    whiparoundIntegrationCheckCredentials = async () => {

        this.setState({whiparoundIntegrationCredentialsVerificationPending: true});

        await RRW_SIMULATE_DELAY_DEV_ONLY(2000);

        this.setState({
            whiparoundIntegrationCredentialsVerificationPending: false,
            whiparoundIntegrationCredentialsVerificationSucceeded: true
        });
    }

    componentWillUnmount() {
        clearTimeout(this.applyIntegrationsWhiparoundCredentialsTimeoutId);
    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.integrationsExpandReference,
            this.props.integrationsWhiparoundCredentialsExpandReference
        ]);
    }

    render() {
        
        let moreInfoTooltipClass = "more-info-tooltip whiparound-tooltip";
        if (this.state.moreInfoTooltipVisible) {
            moreInfoTooltipClass += " visible";
        }
        let integrationStatusMessageClass = "integration-status";
        switch (this.props.integrationsWhiparoundCredentialsStatus) {
            case "ERROR":
                integrationStatusMessageClass += " error-message";
                break;
            /* I'm not certain about this:
            case "ENABLED":
                integrationStatusMessageClass += " success-message";
                break; */
            default:
                integrationStatusMessageClass += " info-message";
                break;
        }
        return (            
            <div className="setting-group-horiz">
                <div className={moreInfoTooltipClass}>
                    {strings.settings_global_integrations_whiparound_more_info}
                </div>
                <div className={this.props.integrationsWhiparoundCredentialsExpandReferenceIsExpanded ? "subgroup" : "subgroup collapsed"}>
                    <div>
                        <h5 className="subgroup-header">
                            <button disabled={true} // SUBSECTION_COLLAPSING_DISABLED
                                className={this.props.integrationsWhiparoundCredentialsExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                                onClick={() => {
                                    this.props.expandOrCollapseStateForUIReferences(
                                        !this.props.integrationsWhiparoundCredentialsExpandReferenceIsExpanded,
                                        [this.props.integrationsWhiparoundCredentialsExpandReference])
                                }}>
                                {strings.settings_global_integrations_whiparound_header}
                                <span
                                    className="more-info"
                                    onMouseEnter={() => {this.setState({moreInfoTooltipVisible: true})}}
                                    onMouseLeave={() => {this.setState({moreInfoTooltipVisible: false})}}
                                >
                                    <i className="material-icons">
                                        info
                                    </i>
                                </span>
                                <i className="material-icons disclosure">keyboard_arrow_up</i>
                            </button>
                        </h5>
                    </div>
                    <div className="description">
                        <a href="https://help.whiparound.com/en" target="_blank" rel="noopener noreferrer" className="help">
                            <i className="material-icons">
                                help
                            </i>
                            {strings.help_menu_title}
                        </a>
                    </div>
                    <div className="setting-group">
                        <div className="form no-form-indent">
                            {this.props.integrationsWhiparoundCredentialsApiKey ?
                                <>
                                <div className="account-integrations">
                                    <label>{strings.settings_global_integrations_whiparound_credentials_api_key_label}</label>
                                    <input autoComplete="new-password" disabled type={"text"} value={this.props.integrationsWhiparoundCredentialsApiKey? this.props.integrationsWhiparoundCredentialsApiKey.substring(0,15) + "..." : null} placeholder={strings.settings_global_integrations_whiparound_credentials_api_key_placeholder} onChange={this.handlePasswordChange}></input>
                                </div>
                                <div className="verification-icons">
                                    {/* Verification not supported
                                    this.props.integrationsWhiparoundCredentialsVerificationIsValid ?
                                        <i className="material-icons status-verified">
                                            check_circle_outline
                                        </i>
                                    :
                                        <i className="material-icons status-failed">
                                            error_outline
                                        </i>
                                    */}
                                    {/*this.props.integrationsWhiparoundCredentialsVerificationPending ? <ProgressOverlay /> : null */}
                                </div>
                                <div className="form-actions">
                                    <button onClick={() => {
                                        this.props.showConfirmationDialog(
                                            <ModalContainer title={strings.settings_global_integrations_whiparound_remove_whiparound_credentials} smallDialogMode={true} onClickClose={this.props.dismissConfirmationDialog}>
                                                <div className="message">
                                                    <p>{strings.settings_global_integrations_whiparound_remove_whiparound_credentials_message}</p>
                                                </div>
                                                <div className="actions">
                                                    <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                                                    <button onClick={() => {
                                                        this.applyIntegrationsWhiparoundCredentialsTimeoutId = setTimeout(() => {this.props.timeoutIntegrationsWhiparoundCredentials(undefined)}, UPDATE_SETTINGS_TIMEOUT);
                                                        this.props.dismissConfirmationDialog();
                                                        this.props.applyIntegrationsWhiparoundCredentials(undefined, this.props.integrationsWhiparoundCredentialsIntegrationId) // applying undefined akin to other preexisting 'delete'/'remove' ops in Global Settings
                                                        .then(
                                                            () => {clearTimeout(this.applyIntegrationsWhiparoundCredentialsTimeoutId)},
                                                            () => {clearTimeout(this.applyIntegrationsWhiparoundCredentialsTimeoutId)}
                                                        )
                                                    }} >{strings.action_remove_credentials}</button>
                                                </div>
                                            </ModalContainer>
                                        )
                                    }} className="btn btn-outline-red">{strings.settings_action_remove}</button>
                                </div>
                                </>
                            :
                                // credentials not found
                                <div className="form-actions">
                                    <button className="btn btn-blue" onClick={() => {
                                        this.props.showConfirmationDialog(
                                            <ModalContainer title={strings.settings_global_integrations_whiparound_add_whiparound_credentials} smallDialogMode={true} >
                                                <IntegrationsAddWhiparoundCredentials
                                                    applyIntegrationsWhiparoundCredentials = {(apiKey) => {
                                                        this.applyIntegrationsWhiparoundCredentialsTimeoutId = setTimeout(() => {this.props.timeoutIntegrationsWhiparoundCredentials(apiKey)}, UPDATE_SETTINGS_TIMEOUT);
                                                        this.props.dismissConfirmationDialog();
                                                        this.props.applyIntegrationsWhiparoundCredentials(apiKey)
                                                        .then(
                                                            () => {clearTimeout(this.applyIntegrationsWhiparoundCredentialsTimeoutId)},
                                                            () => {clearTimeout(this.applyIntegrationsWhiparoundCredentialsTimeoutId)}
                                                        )
                                                    }}
                                                    dismissConfirmationDialog = {this.props.dismissConfirmationDialog}
                                                />
                                            </ModalContainer>
                                        );

                                    }}>{strings.settings_action_add_credentials}</button>
                                </div>
                            }
                        
                        </div>
                        <div className="error-message form-indent">
                            {this.props.integrationsWhiparoundCredentialsErrorMessage}
                        </div>
                        {this.props.integrationsWhiparoundCredentialsStatusMessage &&
                            <div className={integrationStatusMessageClass}>
                                <span className="status-label">{strings.settings_global_integrations_status_colon}</span>{this.props.integrationsWhiparoundCredentialsStatusMessage}
                            </div>
                        }
                        {this.props.integrationsWhiparoundCredentialsPending ? <ProgressOverlay /> : null }
                    </div>
                </div>
            </div>
        );
    }
}

class IntegrationsAddWhiparoundCredentials extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            apiKey: "",
            apiKeyValidationErrorMessage: null
        }
    }

    static propTypes = {
        applyIntegrationsWhiparoundCredentials: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired
    }

    onInputChange = (event) => {
        const trimmedValue = event.target.value.trim();
        switch (event.target.id) {
            case "integrations-whiparound-api-key":
                this.setState({
                    apiKey : trimmedValue,//.substring(0, API_KEY_MIN_LENGTH),
                    apiKeyValidationErrorMessage: trimmedValue.length < API_KEY_MIN_LENGTH ? strings.formatString(strings.settings_global_integrations_whiparound_api_key_min_length_validation_message, API_KEY_MIN_LENGTH) : null
                });
                break;
            default:
                console.warn("IntegrationsAddWhiparoundCredentials onInputChange unknown input");
                return;
        }
    }

    onSubmit = (event) => {
        // assumption, validation already handled onInputChange and submit button is enabled/disabled accordingly
        this.props.applyIntegrationsWhiparoundCredentials(this.state.apiKey);
    }

    render() {
        let disableSubmitButton = false;
        if (this.state.apiKeyValidationErrorMessage) {
            disableSubmitButton = true;
        }
        if (!this.state.apiKey) {
            disableSubmitButton = true;
        }
        return (
            <div className="settings-default-modal integrations">
                <div className="message">
                    <input autoComplete="new-password" type="text" id="integrations-whiparound-api-key" value={this.state.apiKey} placeholder={strings.settings_global_integrations_whiparound_credentials_api_key_placeholder} onChange={this.onInputChange} />
                    <div className="error-message">{this.state.apiKeyValidationErrorMessage}</div>
                </div>
                <div className="error-message">
                    {this.state.credentialsAreIncompleteError}
                </div>
                <div className="actions">
                    <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                    <button onClick={this.onSubmit} disabled={disableSubmitButton} >{strings.action_save}</button>
                </div>
            </div>
        );
    }
}
